module.exports = __webpack_public_path__ + "static/media/2D.1451de5d.png";